/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.draws.internal

import features.draws.models.DrawsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class DrawsRequest : NetworkRequest() {

    suspend fun getDraws(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<DrawsModel> {
        return safeNetworkCall {
            get(
                endpoint = DrawsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
